module.exports = __webpack_public_path__ + "static/slide-4-3455702252bd4d2ee2cc0175aa0b6b2e.jpg";